module.exports = __webpack_public_path__ + "static/media/invoice_avatar.98cda3a0.svg";